import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetInvitationPaymentStatusQuery } from "../../../store/services/payment/payment.service";
import { Box, Button, Chip, Typography } from "@mui/material";
import { STATUS_CONFIG } from "./PaymentCallback";
import { trackEvent } from "../../../utils/analytics";
import { trackMetaEvent } from "../../../utils/metaPixel";
import { trackTikTokEvent } from "../../../utils/tiktokPixel";
import { trackChatGptEvent } from "../../../utils/chatGptPixel";
import { wasPurchaseAlreadyTracked } from "../../../utils/purchaseDedupe";

const POLL_INTERVAL_MS = 2000;
const MAX_POLL_ATTEMPTS = 30; // 60 seconds total before giving up

export function PaddlePaymentCallback() {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const [status, setStatus] = useState<"pending" | "success" | "timeout">("pending");
	const [fetchPaymentStatus, { data }] = useLazyGetInvitationPaymentStatusQuery();
	const config = STATUS_CONFIG[status];

	useEffect(() => {
		if (!data || !data?.isPaid) return;
		if (wasPurchaseAlreadyTracked(data.transactionId)) return;
		trackEvent("pay_wedding_invitation", {
			scope: "Invitations",
			description: "Pay Wedding Invitation"
		});
		trackMetaEvent("pay_wedding_invitation", { invitation_id: id, currency: "USD", value: Number(data.amount) }, true);
		trackTikTokEvent("Purchase", {
			content_id: id,
			content_type: "product",
			currency: "USD",
			value: Number(data.amount)
		});
		trackChatGptEvent("Purchase", { currency: "USD", value: Number(data.amount) });
	}, [id, data]);

	useEffect(() => {
		let attempts = 0;
		let cancelled = false;

		async function poll() {
			try {
				fetchPaymentStatus({ id: id || "" });

				if (cancelled || !data) return;

				if (data.isPaid) {
					setStatus("success");
					return;
				}

				attempts++;
				if (attempts >= MAX_POLL_ATTEMPTS) {
					setStatus("timeout");
					return;
				}

				setTimeout(poll, POLL_INTERVAL_MS);
			} catch {
				if (!cancelled) setTimeout(poll, POLL_INTERVAL_MS);
			}
		}

		poll();
		return () => {
			cancelled = true;
		};
	}, [id, data]);

	return (
		<Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="80vh" px={2}>
			{config.icon}

			<Typography variant="h4" fontWeight="bold" mt={3} textAlign="center" fontFamily="var(--openSans), sans-serif">
				{config.title}
			</Typography>

			<Typography variant="subtitle1" textAlign="center" mt={1} color="text.secondary" maxWidth={440}>
				{config.subtitle}
			</Typography>

			{/*{message && status === "failed" && <Chip label={message} variant="outlined" color="error" sx={{ mt: 2 }} />}*/}

			{/*{txnResponseCode && txnResponseCode !== "APPROVED" && (*/}
			{/*	<Typography variant="caption" color="text.disabled" mt={1}>*/}
			{/*		Code: {txnResponseCode}*/}
			{/*	</Typography>*/}
			{/*)}*/}

			{data?.transactionId && (
				<Typography variant="caption" color="text.disabled" mt={0.5}>
					Transaction ID: {data?.transactionId.slice(-8)}
				</Typography>
			)}

			{status !== "pending" && (
				<Button
					variant="contained"
					size="large"
					sx={{ mt: 4, px: 5 }}
					onClick={() => navigate(`/manageWeddingInvitation/${id}`)}
				>
					Back to Invitation
				</Button>
			)}
		</Box>
	);
}
